
import {
    computed,
    defineComponent,
    ref,
} from 'vue';
import {
    vuetify,
} from '../../vue-plugins';

export default defineComponent({
    name: 'FabBannerBtn',
    props: {
        icon: {
            type: String,
            required: false,
            default: 'mdi-playlist-plus',
        },
        tooltip: {
            type: String,
            required: false,
            default: '',
        },
        color: {
            type: String,
            required: false,
            default: 'secondary',
        },
        subIcon: { type: String, required: false, default: '' },
        text: { type: String, required: false, default: '' },
        order: { type: Number, required: false, default: 1 },
        disabled: { type: Boolean, required: false, default: false },
    },
    setup () {
        return {
            appBarHeight: computed(() => vuetify.framework.breakpoint.smAndDown ? 56 : 64),
            btn: ref(''),
            showTooltip: ref(false),
        };
    },
});
